import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import APICom from "../../utils/helpers/APICom";
import { Button } from 'react-bootstrap';
import '../../assets/Styles/SimulationCSS/SliderSim.css';

const MTS_EmailVerification = ({ HideEmailVerificatinDialog, onStartClick, onSaveEmailDetails, slotMessage, overWritePolygone }) => {
    const [templateUserEmail, setTemplateUserEmail] = useState("info@itcurves.net");
    const [email, setEmail] = useState("");
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [successMsg, setsuccessMsg] = useState('');
    const [isShowOverwriteCheckbox, setIsShowOverwriteCheckbox] = useState(false);
    const [verificationCodeInput, setVerificationCodeInput] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [demoUserRecordID, setDemoUserRecordID] = useState("");
    useEffect(() => {
        if(email == templateUserEmail){
            setIsShowOverwriteCheckbox (true);
        }
        else{
            setIsShowOverwriteCheckbox (false);
        }
    }, [email]);

    const errorMessages = (msg) => {
        if(msg){
            alert(msg);
        }else {
            alert("Please fill in the required fields");
        }
    };
    const isValidEmail = (email) => {
        // Basic email regex pattern for validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const onClickSendEmail = async () => {
        if (!isValidEmail(email)) {
            setEmailError("Please enter a valid email address.");
            return;
        }
        setEmailError("");

        try {
            let data = { "vEmail": email };
            let response = await APICom.fetchData("main", "SimulationScheduler/OtpValidationForSimulation", "post", {}, data);

            if (response?.data?.length > 0) {
                setVerificationCode(response.data[0].verificationCode.toString()); // Store received verification code
                setDemoUserRecordID(response.data[0].NewRecordID.toString()); // Store user record ID
                setIsEmailSent(true); // Switch UI to verification step
            } else {
                setEmailError("Failed to send verification code. Try again.");
            }
        } catch (error) {
            console.error("Error sending verification email", error);
            errorMessages("Error sending verification code. Try again.");
        }
    };
    const onClickCancelHideEmailVerification = () => {
        try {
            HideEmailVerificatinDialog(true);
        } catch (error) {
            console.error("Error hiding email verification dialog", error);
        }
    }

    // const onClickSTartSimulation = async () => {
    //     try {
    //         // Step 1: Validate Email Format
    //         if (!isValidEmail(email)) {
    //             setEmailError("Please enter a valid email address.");
    //             return;
    //         }
    //         setEmailError(""); // Clear previous errors
    
    //         // Step 2: Fetch Verification Code from API
    //         let data = { "vEmail": email };
    //         let response = await APICom.fetchData(
    //             "main", 
    //             "SimulationScheduler/LoginUser", 
    //             "post", 
    //             {}, 
    //             data
    //             //,xCancelSourceForGrid.current
    //         );
    
    //         if (!response?.data?.length) {
    //             errorMessages("Failed to fetch verification code. Try again.");
    //             return;
    //         }
    
    //         setVerificationCode(response.data[0].verificationCode.toString());
    //         setDemoUserRecordID(response.data[0].NewRecordID.toString());
    //         setIsEmailSent(true);
    //         // Step 3: Validate User Input Verification Code
    //         if (verificationCode === verificationCodeInput) {
    //             errorMessages("Congratulations! Your account has been verified. Continuing to microtransit demonstration...");
    
    //             // Step 4: Add a 5-second delay before proceeding
    //             await new Promise(resolve => setTimeout(resolve, 2000));
    
    //             onSaveEmailDetails(email);
    //         } else {
    //             errorMessages("Invalid verification code. Please try again.");
    //         }
    //     } catch (error) {
    //         console.error("Error starting simulation", error);
    //         errorMessages("An error occurred. Please try again later.");
    //     }
    // };
    
    const onClickVerifyCode = async () => {
        if (verificationCodeInput !== verificationCode) {
            setEmailError("Invalid Verification Code. Please try again.");
            return;
        } else {
            setEmailError("");
            setsuccessMsg("Account Verified Successfully.");
            onSaveEmailDetails(email);
            
        }
    }; 
    
    const onClickResendCode = () => {
        setIsEmailSent(false);
        setVerificationCode("");
        setVerificationCodeInput("");
    };


    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
        overWritePolygone(event.target.checked);
    };



    return (
        <div id="MTS_Trips_Information_Componenet">
            <h4>Launch Simulation</h4>

            {emailError && <div style={{ color: "red", marginBottom: "10px" }}>{emailError}</div>}
            {successMsg && <div style={{ color: "white", marginBottom: "10px", fontWeight: "bold" }}>{successMsg}</div>}
            {!successMsg  && ( // ✅ Hide the form if successMsg is set
            !isEmailSent ? (
                <>
                    {/* Email Input and Send Button */}
                    <label>Email</label>
                    <input 
                        type="text" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        placeholder="Enter your email address..." 
                        style={{ marginBottom: "10px", height: "40px", fontSize: "larger" }} 
                    />
                    <div id="MTS_TIC_ButonsDiv">
                        <button id="MTS_TIC_BackBtn" onClick={onClickCancelHideEmailVerification}>Cancel</button>
                        <button id="MTS_TIC_StartBtn" onClick={onClickSendEmail}>Send</button>
                    </div>
                </>
            ) : (
                <>
                    {/* Verification Code Input and Verify/Resend Buttons */}
                    <label>Verification Code: </label>
                    <input 
                        type="text" 
                        value={verificationCodeInput}
                        onChange={(e) => setVerificationCodeInput(e.target.value)}
                        style={{ marginBottom: "10px", height: "40px", fontSize: "larger" }} 
                    />
                    <div id="MTS_TIC_ButonsDiv">
                        <button id="MTS_TIC_BackBtn" onClick={onClickCancelHideEmailVerification}>Cancel</button>
                        <button id="MTS_TIC_CancelBtn" onClick={onClickResendCode}>Resend</button>
                        <button id="MTS_TIC_StartBtn" onClick={onClickVerifyCode}>Verify</button>
                    </div>
                </>
            )
        )}

            {isShowOverwriteCheckbox && (
                <label>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    /> Overwrite Polygon
                </label>
            )}

            <label style={{ color: "beige" }} id="MTS_EmailVerification_ValidationMsg">{slotMessage}</label>
        </div>
    );
};

export default MTS_EmailVerification;
